import {
  BASIC_INFO_ADD_REQUEST,
  BASIC_INFO_ADD_REQUEST_SUCCESS,
  BASIC_INFO_ADD_REQUEST_FAILURE,
  BASIC_INFO_FETCH_REQUEST,
  BASIC_INFO_FETCH_REQUEST_SUCCESS,
  BASIC_INFO_FETCH_REQUEST_FAILURE,
  BASIC_INFO_UPDATE_REQUEST,
  BASIC_INFO_UPDATE_REQUEST_SUCCESS,
  BASIC_INFO_UPDATE_REQUEST_FAILURE,
  BASIC_INFO_CLEAN_REQUEST,
  UPDATE_DRAFT_BASIC_INFO,
  LITERACY_LEVEL_FETCH_REQUEST,
  LITERACY_LEVEL_FETCH_REQUEST_SUCCESS,
  LITERACY_LEVEL_FETCH_REQUEST_FAILURE,
} from './actionTypes';

export const basicInfoFetchRequest = () => {
  return {
    type: BASIC_INFO_FETCH_REQUEST,
  };
};

export const basicInfoFetchRequestSuccess = (data) => {
  return {
    type: BASIC_INFO_FETCH_REQUEST_SUCCESS,
    data,
  };
};

export const basicInfoFetchRequestFailure = (error) => {
  return {
    type: BASIC_INFO_FETCH_REQUEST_FAILURE,
    error,
  };
};

export const basicInfoAddRequest = () => {
  return {
    type: BASIC_INFO_ADD_REQUEST,
  };
};

export const basicInfoAddRequestSuccess = (data) => {
  return {
    type: BASIC_INFO_ADD_REQUEST_SUCCESS,
    data,
  };
};

export const updateDraftBasicInfo = (data) => {
  return {
    type: UPDATE_DRAFT_BASIC_INFO,
    data,
  };
};

export const basicInfoAddRequestFailure = (error) => {
  return {
    type: BASIC_INFO_ADD_REQUEST_FAILURE,
    error,
  };
};

export const basicInfoUpdateRequest = () => {
  return {
    type: BASIC_INFO_UPDATE_REQUEST,
  };
};

export const basicInfoUpdateRequestSuccess = (data) => {
  return {
    type: BASIC_INFO_UPDATE_REQUEST_SUCCESS,
    data,
  };
};

export const basicInfoUpdateRequestFailure = (error) => {
  return {
    type: BASIC_INFO_UPDATE_REQUEST_FAILURE,
    error,
  };
};

export const basicInfoCleanRequest = () => {
  return {
    type: BASIC_INFO_CLEAN_REQUEST,
  };
};

export const literacyLevelFetchRequest = () => {
  return {
    type: LITERACY_LEVEL_FETCH_REQUEST,
  };
};

export const literacyLevelFetchRequestSuccess = (data) => {
  return {
    type: LITERACY_LEVEL_FETCH_REQUEST_SUCCESS,
    data,
  };
};

export const literacyLevelFetchRequestFailure = (error) => {
  return {
    type: LITERACY_LEVEL_FETCH_REQUEST_FAILURE,
    error,
  };
};
